export default class User {
  constructor(data) {
    Object.assign(this, data)
  }

  isLoggedIn() {
    return !!this.token
  }
}
